import React, { useEffect, useState } from "react";
import { getProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProducts()
      .then(setProducts)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="shop-page" className="px-5 md:px-10 py-14 min-h-screen">
      <div className="border-b border-border pb-8 mb-12">
        <h1 className="font-serif text-6xl sm:text-7xl uppercase tracking-tighter leading-none">
          Collections
        </h1>
        <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
          Every thread, a step toward the light
        </p>
      </div>

      {loading ? (
        <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
          Loading…
        </p>
      ) : products.length === 0 ? (
        <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
          Nothing here yet.
        </p>
      ) : (
        <section>
          <div className="flex items-baseline gap-4 mb-8">
            <span className="h-px flex-1 bg-border" />
            <h2 className="font-serif text-2xl sm:text-3xl uppercase tracking-tight text-center">
              2024 MaciasMajnun Spring / Summer Collection
            </h2>
            <span className="h-px flex-1 bg-border" />
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-12">
            {products.map((p, i) => (
              <ProductCard key={p.slug} product={p} index={i} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default Shop;
